import styled from 'styled-components';
import {device} from '../../../../../utils/device';

export const Container = styled.div`
  @media ${device.mobileS} {
    display: flex;
    flex-direction: column;
    height: 100%;
  }
`;

export const Content = styled.div`
  min-height: 500px;
  display: flex;
  flex-direction: column;
  @media ${device.mobileS} {
    flex: 1;
    min-height: unset;
    overflow-y: auto;
  }
`;
export const CaHeader = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 30px;
  @media ${device.mobileS} {
    margin-bottom: 24px;
    ${p =>
      p.border &&
      `
            border-bottom: 1px #D9D9D9 solid;
            margin-bottom: 20px;
            padding-bottom: 15px;
            margin-left: -16px;
            margin-right: -16px;
            padding-left:16px;
            padding-right:16px;
        `}
  }
`;
export const CaHeaderRight = styled.div`
  display: flex;
`;

export const ContentFooter = styled.div`
  margin-top: 160px;
  @media ${device.mobileS} {
    margin-top: 20px;
  }
`;

export const ErrorMsg = styled.p`
  color: #eb2026;
  font-size: 16px;
  font-weight: 400;
  margin-top: 22px;
`;
